var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIletisimIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 9.22C19 3.73 14.74 0 10 0C5.31 0 1 3.65 1 9.28C0.4 9.62 0 10.26 0 11V13C0 14.1 0.9 15 2 15C2.55 15 3 14.55 3 14V9.19C3 5.36 5.95 2.01 9.78 1.9C10.7174 1.87149 11.6509 2.03143 12.5253 2.37034C13.3997 2.70925 14.1972 3.22024 14.8705 3.87301C15.5438 4.52579 16.0792 5.30707 16.445 6.17057C16.8108 7.03407 16.9995 7.96222 17 8.9V16H10C9.45 16 9 16.45 9 17C9 17.55 9.45 18 10 18H17C18.1 18 19 17.1 19 16V14.78C19.59 14.47 20 13.86 20 13.14V10.84C20 10.14 19.59 9.53 19 9.22Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7 11C7.55228 11 8 10.5523 8 10C8 9.44772 7.55228 9 7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16 8.03C15.7615 6.62413 15.0334 5.34796 13.9444 4.42738C12.8555 3.5068 11.4759 3.00117 10.05 3C7.01997 3 3.75997 5.51 4.01997 9.45C5.2531 8.94539 6.34221 8.14349 7.1902 7.11578C8.03818 6.08808 8.61869 4.86652 8.87997 3.56C10.19 6.19 12.88 8 16 8.03Z",
    fill: "#007FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIletisimIcon);
export default __webpack_public_path__ + "static/media/iletisimIcon.b9ea430660269ed14b7f054bd738bbcc.svg";
export { ForwardRef as ReactComponent };